import { combineReducers } from 'redux';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import completedAudit from './completedAudit';
import filters from './filters';
import saveAssetAudit from './saveAssetAudit';
import table from './table';

const auditResults = combineReducers({
  completedAudit,
  filters,
  saveAssetAudit,
  table,
});

export default auditResults;

export const getAuditResultsAppliedAuditorAssetId = state =>
  state.assetAudit.auditResults.filters?.applied?.auditorAssetId;

export const getAuditResultsSelectedAuditorAssetId = state =>
  state.assetAudit.auditResults.filters?.selected?.auditorAssetId;

export const getAuditResultsAuditorAssets = state =>
  state.assetAudit.auditResults.filters.auditorAssets.response.data;

export const getAuditResultsAuditorAssetsIsLoading = state =>
  state.assetAudit.auditResults.filters.auditorAssets.isLoading;

export const getAuditResultsIsCompletedAudit = state => {
  if (!state.assetAudit.auditResults.completedAudit.response?.status) {
    return null;
  }
  return (
    state.assetAudit.auditResults.completedAudit.response?.status ===
    HttpStatus.OK.value
  );
};

export const getAuditResultsCompletedAuditIsLoading = state =>
  state.assetAudit.auditResults.completedAudit.isLoading;

export const getAuditResponseData = state => state.response?.data;

export const getAuditResultsResponseData = state =>
  getAuditResponseData(
    state.assetAudit.auditResults.table.incidentsComparison
  ) || getAuditResponseData(state.assetAudit.auditResults.saveAssetAudit);

export const getAuditResponseIsLoading = state => {
  return state.isLoading;
};

export const getAuditResultsIsLoading = state =>
  getAuditResponseIsLoading(
    state.assetAudit.auditResults.table.incidentsComparison
  ) || getAuditResponseIsLoading(state.assetAudit.auditResults.saveAssetAudit);

export const getAuditResponseTotalElements = state =>
  state.response.data?.totalElements;

export const getAuditResultsTotalResults = state =>
  getAuditResponseTotalElements(
    state.assetAudit.auditResults.table.incidentsComparison
  ) ??
  getAuditResponseTotalElements(state.assetAudit.auditResults.saveAssetAudit);

export const getAuditResultsCreateIncidentsIsLoading = state =>
  state.assetAudit.auditResults.table.createIncidents.isLoading;
